import {isNil} from 'ramda';

import type {EagGridState} from '../store/createEagGridStore';
import type {EagColumn} from '../types/EagColumn';
import {isClipboardCopyAllowed} from './isClipboardCopyAllowed';
import type {ClipboardCopyTarget} from './resolveClipboardCopyTarget';

/** Columns are the latest visible data columns in display order, supplied by the grid layout. */
export function resolveRowClipboardCopyTarget(
  state: EagGridState,
  rowId: string,
  columns: EagColumn[]
): ClipboardCopyTarget | null {
  const row = state.rows.find((candidate) => candidate.id === rowId);
  if (
    !isClipboardCopyAllowed(
      state,
      columns.map((column) => column.key)
    ) ||
    isNil(row)
  ) {
    return null;
  }

  return {rows: [row], columns};
}
